import { gql, useMutation } from '@apollo/client';

import type { UpsertVehicleMutation, UpsertVehicleMutationVariables } from './__generated__/useUpsertVehicle.gql';

const UPSERT_VEHICLE = gql`
  mutation UpsertVehicle($input: UpsertVehicleInput!) {
    upsertVehicle(input: $input) {
      id
      ownership
      ownershipOther
      year
      make
      model
    }
  }
`;

/**
 * Creates or updates a family `Vehicle`. The mutation returns the displayed
 * fields, so an update merges into Apollo's normalized cache in place. A create
 * has no id to merge onto, so callers that need the new row in the list pass
 * `refetchQueries: ['GetVehicles']` (plus `awaitRefetchQueries` if they must wait
 * for it) on the call — the hook itself stays side-effect-free.
 */
export const useUpsertVehicle = () => {
  return useMutation<UpsertVehicleMutation, UpsertVehicleMutationVariables>(UPSERT_VEHICLE);
};
